var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(`width: ${_vm.size}px; min-width: ${_vm.size}px; height: ${_vm.size}px; min-height: ${_vm.size}px; background-color: ${
    _vm.color ? _vm.color : 'transparent'
  }; border-radius: 50%; overflow: hidden; display: ${_vm.display};`)})
}
var staticRenderFns = []

export { render, staticRenderFns }